/**
 * Verifica se a transportadora é Abbiamo
 * 
 * @param {string} carrier
 *  
 * @returns {boolean} 
 */
export const isCarrierAbbiamo = (carrier) => carrier?.toUpperCase() === "ABBIAMO";

/**
 * Verifica se a transportadora é Packk
 * 
 * @param {string} carrier
 *  
 * @returns {boolean} 
 */
export const isCarrierPackk = (carrier) => carrier?.toUpperCase() === "PACKK";